export const SEO_CONTENT = {
  faq: [
    {
      question: "Pourquoi choisir SuperAsso pour la gestion de mon association ?",
      answer: "SuperAsso est conçu spécifiquement pour les petites associations françaises. Contrairement aux logiciels complexes, nous nous concentrons sur l'essentiel : la gestion des membres, la trésorerie simplifiée et la communication efficace, sans fioritures inutiles."
    },
    {
      question: "SuperAsso est-il vraiment gratuit pour les petites associations ?",
      answer: "Oui, notre version de base est gratuite et le restera. Elle permet de gérer jusqu'à 50 membres et inclut les outils fondamentaux de bureau, de comptabilité et de communication pour aider votre association loi 1901 à démarrer sans frais."
    },
    {
      question: "Comment SuperAsso aide-t-il les trésoriers d'association ?",
      answer: "Nous simplifions la saisie des recettes et dépenses. SuperAsso génère automatiquement votre bilan et votre compte de résultat, transformant une tâche administrative complexe en un processus simple et rapide, même sans expertise comptable."
    },
    {
      question: "Puis-je gérer mes adhésions et mes membres facilement ?",
      answer: "Absolument. SuperAsso remplace vos fichiers Excel par un répertoire dynamique. Vous pouvez suivre les adhésions, stocker les documents importants et communiquer avec vos membres via des newsletters intégrées en quelques clics."
    },
    {
      question: "SuperAsso est-il une alternative à AssoConnect, HelloAsso ou Yapla ?",
      answer: "Alors que ces plateformes sont souvent conçues pour de grosses structures ou se limitent à la collecte de fonds, SuperAsso est l'outil 'mains dans le cambouis' pour le quotidien du bureau. Nous nous adressons aux petites associations qui ont besoin de gérer efficacement leurs réunions, leurs tâches et leur trésorerie sans payer des abonnements exorbitants."
    },
    {
      question: "Est-il possible de rédiger les statuts de mon association sur la plateforme ?",
      answer: "Oui, nous proposons un assistant de rédaction pour vos statuts et règlements intérieurs. C'est l'outil idéal pour poser les bases juridiques de votre association sereinement."
    }
  ],
  whySuperAsso: {
    title: "L'assistant 'mains dans le cambouis' pour votre bureau d'association",
    description: "Gérer une petite association loi 1901 demande du temps et une énergie folle. SuperAsso est né sur le terrain, pour répondre au vrai quotidien du bureau : de la prise de notes en réunion à la trésorerie sans prise de tête. C'est l'outil pas cher et ultra-concret pour les bénévoles qui veulent agir plutôt que de faire de l'administratif."
  }
};

export const STRUCTURED_DATA = {
  software: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SuperAsso",
    "operatingSystem": "All",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "EUR"
    },
    "description": "Logiciel de gestion tout-en-un pour les associations françaises : membres, trésorerie, newsletters et administratif."
  }
};
